// // import * as React from 'react';
// // import { useTheme } from '@mui/material/styles';
// // import {
// // 	Box,
// // 	List,
// // 	CssBaseline,
// // 	Divider,
// // 	IconButton,
// // 	ListItem,
// // 	ListItemButton,
// // 	ListItemIcon,
// // 	ListItemText,
// // 	Typography,
// // 	Badge,
// // 	Tooltip,
// // } from '@mui/material';
// // import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// // import DashboardIcon from '@mui/icons-material/Dashboard';
// // import CategoryIcon from '@mui/icons-material/Category';
// // // import OrderIcon from '@mui/icons-material/ShoppingCart';
// // // import ProductIcon from '@mui/icons-material/Store';
// // import CustomerIcon from '@mui/icons-material/People';
// // // import EnquiriesIcon from '@mui/icons-material/QuestionAnswer';
// // import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
// // import LogoutIcon from '@mui/icons-material/Logout';
// // import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// // import ListAltIcon from '@mui/icons-material/ListAlt';
// // import ListIcon from '@mui/icons-material/List';
// // import MailOutlineIcon from '@mui/icons-material/MailOutline';
// // import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// // import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
// // import BorderAllRoundedIcon from '@mui/icons-material/BorderAllRounded';
// // import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
// // import NearMeIcon from '@mui/icons-material/NearMe';
// // import useSound from 'use-sound';
// // // import soundEffect from '../../../public/assets/mixkit-correct-answer-tone-2870.wav';
// // import Notifications from './Notfications';
// // import { GetAllNotifications } from '../../services/api/Notifications';
// // import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';

// // export default function SideBar() {
// // 	const theme = useTheme();
// // 	const [open, setOpen] = React.useState(false);
// // 	const navigate = useNavigate();
// // 	const location = useLocation();
// // 	const [notifications, setNotifications] = React.useState([]);
// // 	const [anchorEl, setAnchorEl] = React.useState(null);
// // 	const notificationOpen = Boolean(anchorEl);
// // 	const notificationId = notificationOpen ? 'notification-popover' : undefined;
// // 	const [notificationcount, setNotificationCount] = React.useState(0);
// // 	const [playSound] = useSound<any>('/assets/mixkit-correct-answer-tone-2870.wav');
// // 	const handleNotificationClick = (event: any) => {
// // 		setAnchorEl(event.currentTarget);
// // 	};

// // 	const handleNotificationClose = () => {
// // 		setAnchorEl(null);
// // 	};

// // 	const handleDrawerToggle = () => {
// // 		setOpen((prevOpen) => !prevOpen);
// // 	};

// // 	const handleLogout = () => {
// // 		localStorage.clear(); // Clear auth data
// // 		navigate('/login'); // Redirect to login page
// // 	};
// // 	const menuItems = [
// // 		{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
// // 		{ text: 'Categories', icon: <CategoryIcon />, path: '/category' },
// // 		{ text: 'Sub Categories', icon: <ListIcon />, path: '/sub-categories' },
// // 		{ text: 'Menu', icon: <ListAltIcon />, path: '/menu' },
// // 		{ text: 'Enquiries', icon: <MailOutlineIcon />, path: '/enquiries' },
// // 		{ text: 'Quotations', icon: <CustomerIcon />, path: '/quotation' },
// // 		{ text: 'Booking', icon: <LibraryBooksOutlinedIcon />, path: '/booking' },
// // 		{ text: 'Type', icon: <BorderAllRoundedIcon />, path: '/type' },
// // 		{ text: 'Our Events', icon: <NearMeIcon />, path: '/our-events' },
// // 		{ text: 'Reports', icon: <SignalCellularAltIcon />, path: '/report' },
// // 	];

// // 	const fetchNotifications = async () => {
// // 		const response = await GetAllNotifications();
// // 		if (response.data) {
// // 			console.log(response);
// // 			playSound();
// // 			setNotifications(response?.data?.notifications);

// // 			setNotificationCount(
// // 				response?.data?.notifications?.filter((n: any) => !n?.isRead)?.length
// // 			);
// // 		}
// // 	};
// // 	React.useEffect(() => {
// // 		const token = localStorage.getItem('token');
// // 		const refresh = localStorage.getItem('refresh');

// // 		if (!token?.trim() || !refresh?.trim()) {
// // 			navigate('/login');
// // 		}
// // 		fetchNotifications();
// // 	}, []);

// // 	return (
// // 		<Box sx={{ display: 'flex' }}>
// // 			<CssBaseline />

// // 			{/* Sidebar */}
// // 			<Drawer variant="permanent" open={open}>
// // 				<DrawerHeader
// // 					sx={{
// // 						display: 'flex',
// // 						justifyContent: 'space-between',
// // 						alignItems: 'center',
// // 						background: '#F2F2F2',
// // 						padding: '5px',
// // 						height: '64px',
// // 					}}
// // 				>
// // 					{/* Logo */}
// // 					<Box
// // 						sx={{
// // 							display: open ? 'flex' : 'none',
// // 							justifyContent: 'center',
// // 							width: '100%',
// // 						}}
// // 					>
// // 						<img
// // 							src="/assets/CHAKARAVARTHY CATERING - FINAL LOGO DESIGN 1.png"
// // 							width={100}
// // 							loading="lazy"
// // 							style={{ padding: '12px' }}
// // 							alt="Company Logo"
// // 						/>
// // 					</Box>

// // 					{/* Toggle Button */}
// // 					<IconButton
// // 						onClick={handleDrawerToggle}
// // 						sx={{
// // 							color: 'red',
// // 							'&:hover': {
// // 								backgroundColor: 'rgba(0, 0, 0, 0.1)',
// // 							},
// // 						}}
// // 					>
// // 						{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
// // 					</IconButton>
// // 				</DrawerHeader>

// // 				<Divider />

// // 				{/* Sidebar Menu */}
// // 				<List>
// // 					{menuItems.map((item) => (
// // 						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// // 							<Tooltip title={item.text} placement="right" arrow>
// // 								<ListItemButton
// // 									sx={{
// // 										minHeight: 48,
// // 										px: 2.5,
// // 										backgroundColor:
// // 											location.pathname === item.path ? '#CA0005' : 'inherit',
// // 										color:
// // 											location.pathname === item.path ? 'white' : 'inherit',
// // 										// '&:hover': {
// // 										// 	backgroundColor:
// // 										// 		location.pathname === item.path ? '#CA0005' : '#f0f0f0',
// // 										// },
// // 										// transition: 'color 0.6s ease',
// // 										transition: 'color 0.6s ease, background-color 0.3s ease',
// // 										'&:hover': { color: 'white' },
// // 										justifyContent: open ? 'initial' : 'center',
// // 									}}
// // 									onClick={() => {
// // 										navigate(item.path);
// // 										setOpen(false); // Auto-close on navigation
// // 									}}
// // 								>
// // 									<ListItemIcon
// // 										sx={{
// // 											minWidth: 0,
// // 											justifyContent: 'center',
// // 											color:
// // 												location.pathname === item.path
// // 													? 'white'
// // 													: 'inherit',
// // 											mr: open ? 3 : 'auto',
// // 										}}
// // 									>
// // 										{item.icon}
// // 									</ListItemIcon>
// // 									<ListItemText
// // 										primary={item.text}
// // 										sx={{ opacity: open ? 1 : 0 }}
// // 									/>
// // 								</ListItemButton>
// // 							</Tooltip>
// // 						</ListItem>
// // 					))}
// // 				</List>

// // 				<List sx={{ marginTop: 'auto' }}>
// // 					<ListItem disablePadding sx={{ display: 'block' }}>
// // 						<Tooltip title={'Logout'} placement="right" arrow>
// // 							<ListItemButton
// // 								onClick={handleLogout}
// // 								sx={{
// // 									minHeight: 48,
// // 									px: 2.5,
// // 									justifyContent: open ? 'initial' : 'center',
// // 									'&:hover': { color: 'white' },
// // 								}}
// // 							>
// // 								<ListItemIcon
// // 									sx={{
// // 										minWidth: 0,
// // 										justifyContent: 'center',
// // 										mr: open ? 3 : 'auto',
// // 									}}
// // 								>
// // 									<LogoutIcon />
// // 								</ListItemIcon>
// // 								<ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0 }} />
// // 							</ListItemButton>
// // 						</Tooltip>
// // 					</ListItem>
// // 				</List>
// // 			</Drawer>

// // 			{/* Navbar */}
// // 			<Box component="main" sx={{ flexGrow: 1, p: 0 }}>
// // 				<Box
// // 					sx={{
// // 						// display: 'flex',
// // 						// justifyContent: 'space-between',
// // 						alignItems: 'center',
// // 						background: '#F2F2F2',
// // 						padding: '5px',
// // 						// width: '100%',
// // 						position: 'fixed',
// // 						zIndex: 1,
// // 						top: 0,
// // 						left: 50,
// // 						right: 0,
// // 						// marginLeft: open ? '240px' : '0',
// // 						// transition: 'margin-left 0.3s',
// // 						// padding: '0 16px',

// // 						// height: '64px',
// // 					}}
// // 				>
// // 					<DrawerHeader
// // 						sx={{
// // 							display: 'flex',
// // 							alignItems: 'center',
// // 							justifyContent: 'space-between',
// // 						}}
// // 					>
// // 						{/* Current Page Title */}
// // 						<Box sx={{ marginLeft: '15px' }}>
// // 							<Typography
// // 								sx={{
// // 									fontFamily: 'Quicksand',
// // 									fontWeight: '600',
// // 									fontSize: '19px',
// // 									textTransform: 'capitalize',
// // 								}}
// // 							>
// // 								{location?.pathname === '/'
// // 									? 'Dashboard'
// // 									: location?.pathname?.split('/')[1]}
// // 							</Typography>
// // 							<Typography variant="body2">{new Date().toDateString()}</Typography>
// // 						</Box>

// // 						{/* Notification Icon */}
// // 						<Box>
// // 							<IconButton
// // 								sx={{
// // 									color: 'red',
// // 									// marginRight: '6rem',
// // 								}}
// // 								onClick={handleNotificationClick}
// // 							>
// // 								<Badge badgeContent={notificationcount} color="error">
// // 									<NotificationsNoneOutlinedIcon />
// // 								</Badge>
// // 							</IconButton>
// // 						</Box>
// // 					</DrawerHeader>
// // 				</Box>

// // 				<div style={{ marginTop: '4rem' }}>
// // 					<Notifications
// // 						notifications={notifications}
// // 						anchorEl={anchorEl}
// // 						notificationOpen={notificationOpen}
// // 						handleNotificationClose={handleNotificationClose}
// // 						fetchNotifications={fetchNotifications}
// // 						notificationId={notificationId}
// // 					/>
// // 				</div>
// // 				<Outlet />
// // 			</Box>
// // 		</Box>
// // 	);
// // }
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
// // ==============================================================================================================================================================
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import {
	Box,
	List,
	CssBaseline,
	Divider,
	IconButton,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Typography,
	Badge,
	Tooltip,
	Link,
} from '@mui/material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CategoryIcon from '@mui/icons-material/Category';
import CustomerIcon from '@mui/icons-material/People';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ListIcon from '@mui/icons-material/List';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import BorderAllRoundedIcon from '@mui/icons-material/BorderAllRounded';
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
import NearMeIcon from '@mui/icons-material/NearMe';
import useSound from 'use-sound';
// import notificationSound from '../..'; // Make sure this path is correct
import Notifications from './Notfications';
import { GetAllNotifications } from '../../services/api/Notifications';
import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';

export default function SideBar() {
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const navigate = useNavigate();
	const location = useLocation();
	const [notifications, setNotifications] = React.useState([]);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const notificationOpen = Boolean(anchorEl);
	const notificationId = notificationOpen ? 'notification-popover' : undefined;
	const [notificationcount, setNotificationCount] = React.useState(0);
	const NOTIFICATION_INTERVAL = 3600000;
	// Initialize sound with proper configuration
	const [playSound] = useSound('/assets/notification-off-269282.mp3', {
		// volume: 0.5,
		interrupt: true,
		onload: () => console.log('Sound loaded'),
		onerror: (error: any) => console.error('Sound error:', error),
	});

	const handleNotificationClick = (event: any) => {
		setAnchorEl(event.currentTarget);
	};

	const handleNotificationClose = () => {
		setAnchorEl(null);
	};

	const handleDrawerToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleLogout = () => {
		localStorage.clear();
		navigate('/login');
	};

	const menuItems = [
		{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
		{ text: 'Categories', icon: <CategoryIcon />, path: '/category' },
		{ text: 'Sub Categories', icon: <ListIcon />, path: '/sub-categories' },
		{ text: 'Fixed Menu', icon: <ListAltIcon />, path: '/fixed-menu' },
		{ text: 'Enquiries', icon: <MailOutlineIcon />, path: '/enquiries' },
		{ text: 'Quotations', icon: <CustomerIcon />, path: '/quotation' },
		{ text: 'Booking', icon: <LibraryBooksOutlinedIcon />, path: '/booking' },
		{ text: 'Event Type', icon: <BorderAllRoundedIcon />, path: '/event-type' },
		{ text: 'Our Events', icon: <NearMeIcon />, path: '/our-events' },
		{ text: 'Reports', icon: <SignalCellularAltIcon />, path: '/report' },
	];

	const fetchNotifications = async () => {
		try {
			const response = await GetAllNotifications();
			if (response.data) {
				playSound();
				const newNotifications = response.data.notifications;
				const newUnreadCount = newNotifications.filter((n: any) => !n.isRead).length;
				// Play sound only if there are new unread notifications
				setNotifications(newNotifications);
				setNotificationCount(newUnreadCount);
			}
		} catch (error) {
			console.error('Error fetching notifications:', error);
		}
	};

	React.useEffect(() => {
		const token = localStorage.getItem('token');
		const refresh = localStorage.getItem('refresh');

		if (!token?.trim() || !refresh?.trim()) {
			navigate('/login');
		}

		// Initial fetch
		fetchNotifications();

		// Set up polling for new notifications (optional)
		// const intervalId = setInterval(fetchNotifications, 3000); // Check every 30 seconds
		const intervalId = setInterval(fetchNotifications, NOTIFICATION_INTERVAL); // Check every 30 seconds

		return () => clearInterval(intervalId);
	}, []);

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />

			{/* Sidebar */}
			<Drawer variant="permanent" open={open}>
				<DrawerHeader
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						background: '#F2F2F2',
						padding: '5px',
						height: '64px',
					}}
				>
					<Box
						sx={{
							display: open ? 'flex' : 'none',
							justifyContent: 'center',
							width: '100%',
						}}
						component={Link}
						href="/"
					>
						<img
							src="/assets/CHAKARAVARTHY CATERING - FINAL LOGO DESIGN 1.png"
							width={100}
							loading="lazy"
							style={{ padding: '12px' }}
							alt="Company Logo"
						/>
					</Box>

					<IconButton
						onClick={handleDrawerToggle}
						sx={{
							color: 'red',
							'&:hover': {
								backgroundColor: 'rgba(0, 0, 0, 0.1)',
							},
						}}
					>
						{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
					</IconButton>
				</DrawerHeader>

				<Divider />

				<List>
					{menuItems.map((item) => (
						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
							<Tooltip title={item.text} placement="right" arrow>
								<ListItemButton
									sx={{
										minHeight: 48,
										px: 2.5,
										backgroundColor:
											location.pathname === item.path ? '#CA0005' : 'inherit',
										color:
											location.pathname === item.path ? 'white' : 'inherit',
										transition: 'color 0.6s ease, background-color 0.3s ease',
										'&:hover': { color: 'white' },
										justifyContent: open ? 'initial' : 'center',
									}}
									onClick={() => {
										navigate(item.path);
										setOpen(false);
									}}
								>
									<ListItemIcon
										sx={{
											minWidth: 0,
											justifyContent: 'center',
											color:
												location.pathname === item.path
													? 'white'
													: 'inherit',
											mr: open ? 3 : 'auto',
										}}
									>
										{item.icon}
									</ListItemIcon>
									<ListItemText
										primary={item.text}
										sx={{ opacity: open ? 1 : 0 }}
									/>
								</ListItemButton>
							</Tooltip>
						</ListItem>
					))}
				</List>

				<List sx={{ marginTop: 'auto' }}>
					<ListItem disablePadding sx={{ display: 'block' }}>
						<Tooltip title={'Logout'} placement="right" arrow>
							<ListItemButton
								onClick={handleLogout}
								sx={{
									minHeight: 48,
									px: 2.5,
									justifyContent: open ? 'initial' : 'center',
									'&:hover': { color: 'white' },
								}}
							>
								<ListItemIcon
									sx={{
										minWidth: 0,
										justifyContent: 'center',
										mr: open ? 3 : 'auto',
									}}
								>
									<LogoutIcon />
								</ListItemIcon>
								<ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0 }} />
							</ListItemButton>
						</Tooltip>
					</ListItem>
				</List>
			</Drawer>

			{/* Main Content */}
			<Box component="main" sx={{ flexGrow: 1, p: 0 }}>
				<Box
					sx={{
						alignItems: 'center',
						background: '#F2F2F2',
						padding: '5px',
						position: 'fixed',
						zIndex: 999,
						top: 0,
						left: 50,
						right: 0,
					}}
				>
					<DrawerHeader
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
						}}
					>
						<Box sx={{ marginLeft: '15px' }}>
							<Typography
								sx={{
									fontFamily: 'Quicksand',
									fontWeight: '600',
									fontSize: '19px',
									textTransform: 'capitalize',
								}}
							>
								{location?.pathname === '/'
									? 'Dashboard'
									: location?.pathname?.split('/')[1] || 'Dashboard'}
							</Typography>
							<Typography variant="body2">{new Date().toDateString()}</Typography>
						</Box>

						<Box>
							<IconButton
								sx={{
									color: 'red',
								}}
								onClick={handleNotificationClick}
							>
								<Badge badgeContent={notificationcount} color="error">
									<NotificationsNoneOutlinedIcon />
								</Badge>
							</IconButton>
						</Box>
					</DrawerHeader>
				</Box>

				<div style={{ marginTop: '4rem' }}>
					<Notifications
						notifications={notifications}
						anchorEl={anchorEl}
						notificationOpen={notificationOpen}
						handleNotificationClose={handleNotificationClose}
						fetchNotifications={fetchNotifications}
						notificationId={notificationId}
					/>
				</div>
				<Outlet />
			</Box>
		</Box>
	);
}
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// ==============================================================================================================================================================
// import * as React from 'react';
// import { useTheme } from '@mui/material/styles';
// import {
// 	Box,
// 	List,
// 	CssBaseline,
// 	Divider,
// 	IconButton,
// 	ListItem,
// 	ListItemButton,
// 	ListItemIcon,
// 	ListItemText,
// 	Typography,
// 	Badge,
// 	Tooltip,
// } from '@mui/material';
// import { Outlet, useNavigate, useLocation } from 'react-router-dom';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import CategoryIcon from '@mui/icons-material/Category';
// import CustomerIcon from '@mui/icons-material/People';
// import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
// import LogoutIcon from '@mui/icons-material/Logout';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import ListAltIcon from '@mui/icons-material/ListAlt';
// import ListIcon from '@mui/icons-material/List';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
// import BorderAllRoundedIcon from '@mui/icons-material/BorderAllRounded';
// import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined';
// import NearMeIcon from '@mui/icons-material/NearMe';
// import useSound from 'use-sound';
// import Notifications from './Notfications';
// import { GetAllNotifications } from '../../services/api/Notifications';
// import { Drawer, DrawerHeader } from '../../components/component/ThemeComponent';

// export default function SideBar() {
// 	const theme = useTheme();
// 	const [open, setOpen] = React.useState(false);
// 	const navigate = useNavigate();
// 	const location = useLocation();
// 	const [notifications, setNotifications] = React.useState([]);
// 	const [previousNotifications, setPreviousNotifications] = React.useState([]);
// 	const [anchorEl, setAnchorEl] = React.useState(null);
// 	const notificationOpen = Boolean(anchorEl);
// 	const notificationId = notificationOpen ? 'notification-popover' : undefined;
// 	const [notificationcount, setNotificationCount] = React.useState(0);
// 	// const NOTIFICATION_INTERVAL = 3600000;
// 	// const NOTIFICATION_INTERVAL = 3600;

// 	const [playSound] = useSound('/assets/notification-off-269282.mp3', {
// 		interrupt: true,
// 		onload: () => console.log('Sound loaded'),
// 		onerror: (error: any) => console.error('Sound error:', error),
// 	});

// 	const handleNotificationClick = (event: any) => {
// 		setAnchorEl(event.currentTarget);
// 	};

// 	const handleNotificationClose = () => {
// 		setAnchorEl(null);
// 	};

// 	const handleDrawerToggle = () => {
// 		setOpen((prevOpen) => !prevOpen);
// 	};

// 	const handleLogout = () => {
// 		localStorage.clear();
// 		navigate('/login');
// 	};

// 	const menuItems = [
// 		{ text: 'Dashboard', icon: <DashboardIcon />, path: '/' },
// 		{ text: 'Categories', icon: <CategoryIcon />, path: '/category' },
// 		{ text: 'Sub Categories', icon: <ListIcon />, path: '/sub-categories' },
// 		{ text: 'Fixed Menu', icon: <ListAltIcon />, path: '/fixed-menu' },
// 		{ text: 'Enquiries', icon: <MailOutlineIcon />, path: '/enquiries' },
// 		{ text: 'Quotations', icon: <CustomerIcon />, path: '/quotation' },
// 		{ text: 'Booking', icon: <LibraryBooksOutlinedIcon />, path: '/booking' },
// 		{ text: 'Event Type', icon: <BorderAllRoundedIcon />, path: '/event-type' },
// 		{ text: 'Our Events', icon: <NearMeIcon />, path: '/our-events' },
// 		{ text: 'Reports', icon: <SignalCellularAltIcon />, path: '/report' },
// 	];

// 	const fetchNotifications = async () => {
// 		try {
// 			const response = await GetAllNotifications();
// 			if (response.data) {
// 				const newNotifications = response.data.notifications;
// 				const newUnreadCount = newNotifications.filter((n: any) => !n.isRead).length;

// 				// Compare new notifications with previous notifications
// 				const areNotificationsSame =
// 					JSON.stringify(newNotifications) === JSON.stringify(previousNotifications);

// 				if (!areNotificationsSame) {
// 					playSound();
// 				}

// 				setPreviousNotifications(newNotifications);
// 				setNotifications(newNotifications);
// 				setNotificationCount(newUnreadCount);
// 			}
// 		} catch (error) {
// 			console.error('Error fetching notifications:', error);
// 		}
// 	};

// 	React.useEffect(() => {
// 		const token = localStorage.getItem('token');
// 		const refresh = localStorage.getItem('refresh');

// 		if (!token?.trim() || !refresh?.trim()) {
// 			navigate('/login');
// 		}

// 		// Initial fetch
// 		fetchNotifications();

// 		// Set up polling for new notifications
// 		const intervalId = setInterval(fetchNotifications, NOTIFICATION_INTERVAL);

// 		return () => clearInterval(intervalId);
// 	}, [navigate]);

// 	return (
// 		<Box sx={{ display: 'flex' }}>
// 			<CssBaseline />

// 			{/* Sidebar */}
// 			<Drawer variant="permanent" open={open}>
// 				<DrawerHeader
// 					sx={{
// 						display: 'flex',
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 						background: '#F2F2F2',
// 						padding: '5px',
// 						height: '64px',
// 					}}
// 				>
// 					<Box
// 						sx={{
// 							display: open ? 'flex' : 'none',
// 							justifyContent: 'center',
// 							width: '100%',
// 						}}
// 					>
// 						<img
// 							src="/assets/CHAKARAVARTHY CATERING - FINAL LOGO DESIGN 1.png"
// 							width={100}
// 							loading="lazy"
// 							style={{ padding: '12px' }}
// 							alt="Company Logo"
// 						/>
// 					</Box>

// 					<IconButton
// 						onClick={handleDrawerToggle}
// 						sx={{
// 							color: 'red',
// 							'&:hover': {
// 								backgroundColor: 'rgba(0, 0, 0, 0.1)',
// 							},
// 						}}
// 					>
// 						{theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
// 					</IconButton>
// 				</DrawerHeader>

// 				<Divider />

// 				<List>
// 					{menuItems.map((item) => (
// 						<ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// 							<Tooltip title={item.text} placement="right" arrow>
// 								<ListItemButton
// 									sx={{
// 										minHeight: 48,
// 										px: 2.5,
// 										backgroundColor:
// 											location.pathname === item.path ? '#CA0005' : 'inherit',
// 										color:
// 											location.pathname === item.path ? 'white' : 'inherit',
// 										transition: 'color 0.6s ease, background-color 0.3s ease',
// 										'&:hover': { color: 'white' },
// 										justifyContent: open ? 'initial' : 'center',
// 									}}
// 									onClick={() => {
// 										navigate(item.path);
// 										setOpen(false);
// 									}}
// 								>
// 									<ListItemIcon
// 										sx={{
// 											minWidth: 0,
// 											justifyContent: 'center',
// 											color:
// 												location.pathname === item.path
// 													? 'white'
// 													: 'inherit',
// 											mr: open ? 3 : 'auto',
// 										}}
// 									>
// 										{item.icon}
// 									</ListItemIcon>
// 									<ListItemText
// 										primary={item.text}
// 										sx={{ opacity: open ? 1 : 0 }}
// 									/>
// 								</ListItemButton>
// 							</Tooltip>
// 						</ListItem>
// 					))}
// 				</List>

// 				<List sx={{ marginTop: 'auto' }}>
// 					<ListItem disablePadding sx={{ display: 'block' }}>
// 						<Tooltip title={'Logout'} placement="right" arrow>
// 							<ListItemButton
// 								onClick={handleLogout}
// 								sx={{
// 									minHeight: 48,
// 									px: 2.5,
// 									justifyContent: open ? 'initial' : 'center',
// 									'&:hover': { color: 'white' },
// 								}}
// 							>
// 								<ListItemIcon
// 									sx={{
// 										minWidth: 0,
// 										justifyContent: 'center',
// 										mr: open ? 3 : 'auto',
// 									}}
// 								>
// 									<LogoutIcon />
// 								</ListItemIcon>
// 								<ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0 }} />
// 							</ListItemButton>
// 						</Tooltip>
// 					</ListItem>
// 				</List>
// 			</Drawer>

// 			{/* Main Content */}
// 			<Box component="main" sx={{ flexGrow: 1, p: 0 }}>
// 				<Box
// 					sx={{
// 						alignItems: 'center',
// 						background: '#F2F2F2',
// 						padding: '5px',
// 						position: 'fixed',
// 						zIndex: 1,
// 						top: 0,
// 						left: 50,
// 						right: 0,
// 					}}
// 				>
// 					<DrawerHeader
// 						sx={{
// 							display: 'flex',
// 							alignItems: 'center',
// 							justifyContent: 'space-between',
// 						}}
// 					>
// 						<Box sx={{ marginLeft: '15px' }}>
// 							<Typography
// 								sx={{
// 									fontFamily: 'Quicksand',
// 									fontWeight: '600',
// 									fontSize: '19px',
// 									textTransform: 'capitalize',
// 								}}
// 							>
// 								{location?.pathname === '/'
// 									? 'Dashboard'
// 									: location?.pathname?.split('/')[1] || 'Dashboard'}
// 							</Typography>
// 							<Typography variant="body2">{new Date().toDateString()}</Typography>
// 						</Box>

// 						<Box>
// 							<IconButton
// 								sx={{
// 									color: 'red',
// 								}}
// 								onClick={handleNotificationClick}
// 							>
// 								<Badge badgeContent={notificationcount} color="error">
// 									<NotificationsNoneOutlinedIcon />
// 								</Badge>
// 							</IconButton>
// 						</Box>
// 					</DrawerHeader>
// 				</Box>

// 				<div style={{ marginTop: '4rem' }}>
// 					<Notifications
// 						notifications={notifications}
// 						anchorEl={anchorEl}
// 						notificationOpen={notificationOpen}
// 						handleNotificationClose={handleNotificationClose}
// 						fetchNotifications={fetchNotifications}
// 						notificationId={notificationId}
// 					/>
// 				</div>
// 				<Outlet />
// 			</Box>
// 		</Box>
// 	);
// }
